import './TestimonialQuote.css';
import React from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors, injectImageResolution } from '../../utils';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
export const TestimonialQuote = _ref => {
  let {
    fields,
    params,
    background,
    color
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (!fields) {
    console.info('TestimonialQuote component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [TestimonialQuote component is empty: please provide data source]");
    }
    return null;
  }
  const hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  const hasQuoteMark = Boolean(get(fields, 'data.item.hasQuoteMark.jss.value'));
  const hasQuoteText = Boolean(get(fields, 'data.item.quoteText.jss.value'));
  const hasAuthorPicture = Boolean(get(fields, 'data.item.authorPicture.jss.value.src'));
  const hasAuthorName = Boolean(get(fields, 'data.item.authorName.jss.value'));
  const hasAuthorDescription = Boolean(get(fields, 'data.item.authorDescription.jss.value'));
  const primaryColor = get(sitecoreContext, 'themesOfPage.primary') || getPageThemeColors(isVdsite).primary;
  const bgItem = background || get(params, 'BackgroundColorHex') || primaryColor;
  const colorItem = color || get(params, 'ColorHex') || getColorByTheme(primaryColor);
  const hasWhiteBG = bgItem.includes("#fff");
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: `col-sm-12 testimonial testimonial-quote ${hasQuoteMark ? hasWhiteBG ? 'has-quote-mark has-quote-grey-mark' : 'has-quote-mark has-quote-transparent-mark' : hasWhiteBG ? 'no-quote-mark-white-bg no-quote-mark' : 'no-quote-mark'}`,
    "data-cy": "testimonial-quote",
    style: {
      background: bgItem
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "testimonial__wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "testimonial__title"
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    className: "c-title__text",
    tag: "span",
    field: fields.data.item.title.jss,
    "data-cy": "testimonial-quote-title",
    style: {
      color: colorItem
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "testimonial__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "testimonial__quote"
  }, hasQuoteText && /*#__PURE__*/React.createElement("div", {
    className: "c-content__text",
    "data-cy": "testimonial-quote-text"
  }, /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    style: {
      color: colorItem
    },
    field: fields.data.item.quoteText.jss
  }))), (hasAuthorPicture || hasAuthorName || hasAuthorDescription) && /*#__PURE__*/React.createElement("div", {
    className: "testimonial__author"
  }, hasAuthorPicture && /*#__PURE__*/React.createElement("div", {
    className: "c-author__photo"
  }, /*#__PURE__*/React.createElement("img", {
    src: injectImageResolution(fields.data.item.authorPicture.jss.value.src, 40, 40),
    alt: fields.data.item.authorPicture.jss.value.alt,
    "data-cy": "testimonial-quote-author-picture"
  })), (hasAuthorName || hasAuthorDescription) && /*#__PURE__*/React.createElement("div", {
    className: "c-author__info"
  }, hasAuthorName && /*#__PURE__*/React.createElement("strong", {
    className: "c-author__name",
    style: {
      color: colorItem
    },
    "data-cy": "testimonial-quote-author-name"
  }, fields.data.item.authorName.jss.value), hasAuthorDescription && /*#__PURE__*/React.createElement(Text, {
    className: "c-author__role",
    tag: "span",
    style: {
      color: colorItem
    },
    field: fields.data.item.authorDescription.jss,
    "data-cy": "testimonial-quote-author-description"
  }))))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    className,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${QuotesUpStyles} ${rtl ? rtlStyles : ltrStyles} ${className || ""}`,
    componentTabIndex: "disabled"
  }, children);
};
export const QuotesUpStyles = "q1kpmyaw";
export const commonStyles = "c10y3w1o";
export const ltrStyles = "l1omgon9";
export const rtlStyles = "r1yy3pet";
export default TestimonialQuote;